import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as familyActions from '../redux-sagas/actions/familyActions';
import * as actionCreators from '../redux-sagas/actions/actionCreators';
import * as teamActions from '../redux-sagas/actions/teamActions';
import * as leagueActions from '../redux-sagas/actions/leagueActions';
import * as geoActions from '../redux-sagas/actions/geoActions';
import * as seasonActions from '../redux-sagas/actions/seasonActions';
import Invitation from '../components/login/Invitation';
import _ from 'lodash';

const mapStateToProps = state => {
    return {
        loggedIn: state.loggedIn,
        auth: state.auth, 
        league: state.league,
        invitation: state.invitation,
        countries: state.countries,
        country_codes: state.country_codes,
        states: state.states,
        carriers: state.carriers,
        disclaimer: state.disclaimer,
        spotlight: null,
        spotlightOn: state.spotlightOn
    }
}

const mapDispatchToProps = dispatch => {
    return _.extend({
        familyActions: bindActionCreators(familyActions, dispatch),
        teamActions: bindActionCreators(teamActions, dispatch),
        leagueActions: bindActionCreators(leagueActions, dispatch),
        geoActions: bindActionCreators(geoActions, dispatch),
        seasonActions: bindActionCreators(seasonActions, dispatch)
    }, bindActionCreators(actionCreators, dispatch))
}

const App = connect(mapStateToProps, mapDispatchToProps)(Invitation);

export default App;
